<template>
  <div class="banner" v-if="isMaintenance">
    <span>RMA Portal is under maintenance. </span>
    <span @click="maintenanceInfo" class="banner-link">More Info</span>
  </div>
</template>

<script>
import { maintenanceInfo, getStatus } from "@/helpers/maintenance";

export default {
  mounted() {
    getStatus()
      .then(status => {
        this.isMaintenance = status;
      })
      .catch(() => {
        this.isMaintenance = false;
      });
  },
  data() {
    return {
      isMaintenance: false
    };
  },
  methods: {
    maintenanceInfo
  }
};
</script>

<style>
.banner {
  background-color: #da6f38;
  color: white;
  padding: 1ex;
  text-align: center;
  font-weight: bold;
}

.banner-link {
  color: white;
  cursor: pointer;
  text-decoration: underline;
}
</style>
